import { render, staticRenderFns } from "./NeutralIcon.vue?vue&type=template&id=0a8ed203&functional=true&"
import script from "./NeutralIcon.vue?vue&type=script&lang=js&"
export * from "./NeutralIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports